<form [formGroup]="form" (ngSubmit)="submit()" class="p-4">
  <p class="mb-3">{{ "QUOTE.DRAWING.DIALOG.COMPLETE_DRAWING_DESCRIPTION" | translate }}</p>

  <div class="mb-3">
    <p-inputgroup>
      <p-inputgroup-addon><i class="pi pi-link"></i></p-inputgroup-addon>
      <p-floatlabel variant="on" class="flex-1">
        <input
          pInputText
          id="sharepointUrl"
          type="url"
          formControlName="sharepointUrl"
          [placeholder]="'QUOTE.DRAWING.DIALOG.SHAREPOINT_URL_PLACEHOLDER' | translate"
          class="w-full"
        />
        <label for="sharepointUrl">{{ "QUOTE.DRAWING.DIALOG.SHAREPOINT_URL_LABEL" | translate }} *</label>
      </p-floatlabel>
    </p-inputgroup>
    <app-core-errors [control]="form.get('sharepointUrl')"></app-core-errors>
  </div>

  <div class="flex justify-content-end gap-2 mt-4">
    <p-button [label]="'QUOTE.DRAWING.DIALOG.CANCEL' | translate" [text]="true" (onClick)="closeDialog()" />
    <p-button type="submit" [label]="'QUOTE.DRAWING.DIALOG.CONFIRM' | translate" [disabled]="form.invalid" />
  </div>
</form>
